/* eslint-disable */
import { debounce } from "./helpers/debounce";
import { ifMobile, isTablet } from "./chc/helpers";

document.addEventListener("alpine:init", () => {

    Alpine.data("comparator", (props) => {
        return {
            ...props,
            prevWidth: window.innerWidth,
            bpDesktop: 1366,
            bzvcLoaded: false,
            showMore: false,
            isResized: false,
            removeDesktopHeight: [],
            removeMobileHeight: [],
            widthPerCol: 0,
            init () {           
                const debounceResize = debounce(() => {
                    const currWidth = window.innerWidth;

                    if (this.prevWidth === currWidth) return;
                    if (this.ifSmallDevice) this.$refs.stickyHeader.style.top = 0;

                    this.removeDesktopHeight = [];
                    this.removeMobileHeight = [];
                    this.showMore = false;
                    this.prevWidth = currWidth;
                    this.initFunc();
                    this.toggleContent();
                }, 100);

                this.windowEvents(debounceResize);
            },
            initFunc() {
                this.setNewColWidth();
                this.setTopSticky();
                setTimeout(() => this.getHideHeights(), 900);
            },
            windowEvents(debounceResize) {
                window.addEventListener("resize", debounceResize);
                window.addEventListener("scroll", () => this.setShadowHeader());
            },
            scrollToTop() {
                window.scrollTo({ top: 0, behavior: 'smooth' });
            },
            removeZeroRating() {
                const _self = this.$el;
                const bzvcContent = _self.querySelectorAll(".comparator__detailInfo--bzvc");

                bzvcContent.forEach(el => {
                    const bzvc = el.querySelector(".bzvc");
                    const emptyRating = el.querySelector(".comparator__emptyRating");

                    if (!bzvc) {
                        emptyRating.classList.remove("hidden");
                        return;
                    }                        

                    const ratingEl = el.querySelector(".bv-off-screen").textContent;
                    const rating = ratingEl.split(" ")[0];
                    
                    if (rating === "0.0") {
                        bzvc.classList.add("hidden");
                        emptyRating.classList.remove("hidden");
                    }
                });
            },
            ifSmallDevice() {
                return ifMobile() || isTablet() || window.innerWidth < 1025;
            },
            getOffset(el) {
                const rect = el.getBoundingClientRect();
                return {
                  left: rect.left + window.scrollX,
                  top: rect.top + window.scrollY
                };
            },
            getStickyHeight() {
                const stickyHeader = document.querySelector("header[data-sticky='true']");
                const announcementBar = document.querySelector(".announcementBar.sticky");
                const announcementBarHeight = announcementBar? announcementBar.clientHeight : 0;

                return stickyHeader.offsetHeight + announcementBarHeight;
            },
            setNewColWidth() {
                const comparatorWrap = this.$root.querySelectorAll(".comparator__wrap");
                comparatorWrap.forEach(el => this.setCss(el, { width: `100%` }));

                if (!this.ifSmallDevice()) return;

                let widthArr = [];
                const items = this.$refs.stickyHeader.querySelectorAll(".comparator__products");

                items.forEach(el => widthArr.push(el.querySelector(".comparator__name").clientWidth));

                // set min-width for each column
                this.$root.querySelectorAll(".comparator__wrap--details").forEach((el) => {
                    if (!el.offsetParent) return;
                    el.querySelectorAll(".comparator__container").forEach((col, key) => col.style.minWidth = `${widthArr[key]}px`);
                });

                const itemLen = items.length;
                const divideNum = itemLen > 1 ? this.numProduct : itemLen;
                const mainContainer = this.$root.querySelector(".comparator__main");
                const mainWidth = mainContainer.clientWidth;

                // set comparator wrap width
                const containerWidth = (mainWidth / divideNum) - 7;
                const containerWidthMultiplied = containerWidth * itemLen;
                const sumWidth = widthArr.reduce((a, b) => a + b, 0);
                const comparatorWrapWidth = `${containerWidthMultiplied > sumWidth ? containerWidthMultiplied : sumWidth}px`;
                
                comparatorWrap.forEach(el => this.setCss(el, { width: comparatorWrapWidth }));
            },
            setShadowHeader() {                
                const stickyHeader = this.$refs.stickyHeader;
                const { top } = this.getOffset(stickyHeader);
                const stickyHeight = this.getStickyHeight();
                
                if (this.ifSmallDevice()) return;

                const scrollY = window.scrollY + stickyHeight;

                this.setClassEvent({ el: stickyHeader, bool: scrollY >= top, className: "shadowBottom" });
            },
            setClassEvent({ el, bool, className}) {
                const classEvent = bool? "add" : "remove";
                el.classList[classEvent](className);
            },
            setCss(el, style) {
                Object.keys(style).forEach(key => {
                    el.style[key] = style[key];
                });
            },
            setWidth() { 
                const _self = this.$el;
                const wrap = _self.querySelectorAll(".comparator__wrap");

                const itemLen = this.$refs.stickyHeader.querySelectorAll(".comparator__products").length;
                const divideNum = itemLen > 2? 3 : itemLen;

                const mainContainer = this.$el.querySelector(".comparator__main");
                const mainContainerWidth = mainContainer.clientWidth;
                const containerWidth = mainContainerWidth / divideNum;
                const breakPoint = this.ifSmallDevice();
                
                wrap.forEach(el => this.setCss(el, { width: breakPoint ? `${containerWidth * itemLen}px` : "100%" }));
            },
            setTopSticky() {
                window.addEventListener("scroll", () => {
                    const breakPoint = this.ifSmallDevice();
                    const _self = this.$refs.stickyHeader;
                    let sumHeight = 0 ;

                    if (_self.classList.contains("sticky")) _self.style.top = sumHeight;

                    if (breakPoint) return;

                    const buttonSticky = document.querySelector(".buttonSticky--regular.sticky");
                    let buttonStickyrHeight = 0;

                    sumHeight = this.getStickyHeight();

                    if (_self.classList.contains("sticky")) _self.style.top = `${sumHeight}px`;

                    if (buttonSticky) {
                        if (breakPoint) return;

                        buttonStickyrHeight = buttonSticky.clientHeight;
                        const newSumHeight = sumHeight + buttonStickyrHeight;

                        if (_self.classList.contains("sticky")) _self.style.top = `${newSumHeight}px`;
                    }
                });
            },
            noBazaarVoiceWidth() {
                if (this.$refs.bzvc) return;

                let setWidth = 0;
                const _self = this.$el;
                const wrap = _self.querySelectorAll(".comparator__wrap");
                const stickyHeader = this.$refs.stickyHeader;
                const containers = stickyHeader.querySelectorAll(".comparator__container");
                
                containers.forEach(el => (setWidth += el.clientWidth));
                const breakPoint = this.ifSmallDevice();

                wrap.forEach(el => this.setCss(el, { width: breakPoint ? `${setWidth}px` : "100%" }));
            },
            withBazaarVoiceWidth() {
                const bzvc = this.$refs.bzvc;

                if (!bzvc) {
                    this.bzvcLoaded = true;
                    return;
                }

                const bzvcEl = bzvc.querySelector(".bzvc");
                const config = { childList: true };

                const obs = new MutationObserver(mutationList => {
                    for (const mutation of mutationList) {
                        const [ childNode ] = mutation?.addedNodes;  

                        if (!this.bzvcLoaded) this.removeZeroRating();

                        this.bzvcLoaded = true;

                        setTimeout(() => this.setWidth(), 200);
                    }
                });
    
                obs.observe(bzvcEl, config);

                if (this.bzvcLoaded) this.setWidth();
            },
            getHideHeights() {
                this.$el.querySelectorAll(".row-hide").forEach(el => {
                    const desktopClass = el.classList.contains("showMoreContent--desktop");
                    if (el.scrollHeight !== 0) {
                        if (desktopClass) this.removeDesktopHeight.push(el.scrollHeight);
                        else this.removeMobileHeight.push(el.scrollHeight);
                    }
                });
            },
            toggleContent() {
                this.$root.querySelectorAll(".showMoreContent--desktop.row-hide").forEach((el, key) => {
                    this.setCss(el, {
                        height: this.showMore? `${this.removeDesktopHeight[key]}px` : 0,
                        opacity: this.showMore? 1 : 0
                    });
                });

                this.$root.querySelectorAll(".showMoreContent.row-hide").forEach((el, key) => {
                    this.setCss(el, {
                        height: this.showMore? `${this.removeMobileHeight[key]}px`: 0,
                        opacity: this.showMore? 1 : 0,
                    });

                    if (this.showMore) el.style.overflow = "unset";
                    else setTimeout(() => el.style.overflow = "hidden", 300);
                });
            },
            showMoreLess() { 
                this.showMore = !this.showMore;
                this.toggleContent();
            }
        };
    });

});